import { useErrorNotificationApi } from '@equifinance/shared';
import { Brokerage, Brokerages } from '../contexts/brokerages';
import { Assignee } from '../contexts/assignees';
import { ApiCredentials } from '../contexts/apiCredentials';

const apiPath = `${process.env.REACT_APP_BROKER_MANAGEMENT_API_AUTH_PATH}/`; // broker management v2 api

const apiUrl = (path: string) => `${apiPath}${path}`;

export type BrokerManagementApiType = {
  getCompanies: () => Promise<Brokerages>,
  getCompany: (companyId: string) => Promise<Brokerage>,
  getAssignees: (companyId: string) => Promise<{ users: Assignee[] }>,
  getApiCredentials: (companyId: string) => Promise<ApiCredentials>,
  postApiCredentials: (companyId: string) => Promise<ApiCredentials>,
}

const useBrokerManagementApi = (): BrokerManagementApiType => {
  const {
    get,
    post,
  } = useErrorNotificationApi(apiUrl);
  return {
    getCompanies: (): Promise<Brokerages> => get('company/companies'),
    getCompany: (companyId: string): Promise<Brokerage> => get(`company/${companyId}`),
    getAssignees: (companyId: string): Promise<{ users: Assignee[] }> => get(`user/users/${companyId}/list`),
    getApiCredentials: (companyId: string): Promise<ApiCredentials> => get(`company/${companyId}/api-credentials`),
    postApiCredentials: (companyId: string): Promise<ApiCredentials> => post(`company/${companyId}/api-credentials`, {}),
  };
};

export default useBrokerManagementApi;
